<template>
  <section v-if="news.length !== 0" class="news-outer">
    <div class="news-inner">
      <Title title="News" sub-title="最新消息" />
      <el-row :gutter="20">
        <el-col v-for="(item) in news" :key="item.id" :xs="24" :sm="12" :md="8">
          <NewsItem :data-source="item" />
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <router-link to="/news">
          更多消息
        </router-link>
      </el-row>
    </div>
  </section>
</template>
<script>
import Title from '@/components/Title'
import NewsItem from '../News//NewsItem.vue'
import api from '@/api'

export default {
  components: {
    Title,
    NewsItem
  },
  data() {
    return {
      news: []
    }
  },
  mounted() {
    this.getArticle()
  },
  methods: {
    async getArticle() {
      const params = {
        page: 1,
        limit: 3
      }
      const { data, success } = await api.article.list(params)
      if (success) {
        this.news = data.records
      }
    }
  }
}
</script>
<style scoped lang="scss">
.news-outer {
  width: 100%;
  min-height: 80vh;
  @include minWidth992 {
    padding-right: 100px;
  }
}
.news-inner {
  @include InnerContainer();
}
.no-news-text {
  font-size: 20px;
  color: $mainPurple;
  text-align: center;
}
::v-deep a {
  color: $mainPurple;
}
</style>
